import { getThemeFromConfig, logger, readCookie, useWLOrgConfigContext } from '@talos/kyoko';

import { envConfig } from '@src/utils/envConfig';
import { useEffect } from 'react';

/** Retrieve theme for fallback cases where User would never be known (e.g. Unauthorized, App-wide error) */
export const useFallbackTheme = () => {
  const { config, isLoaded } = useWLOrgConfigContext();
  const fallbackTheme = getThemeFromConfig(config);

  useEffect(() => {
    if (isLoaded && fallbackTheme) {
      const { fontUrl } = fallbackTheme;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrl;
      document.head.appendChild(link);
    }
  }, [fallbackTheme, isLoaded]);

  useEffect(() => {
    logger.info('[auth] Unauthorized page rendered', {
      extra: {
        cookie: readCookie(envConfig.VITE_SESSION_COOKIE),
      },
    });
  }, []);

  if (!isLoaded) {
    return null;
  }

  return fallbackTheme;
};
